<template>
    <section class="configurations-page">
        <section class="title">
            <h1>Tipos de Usuários</h1>
            <p>Aqui está todas as opções para personalização do uso do sistema.</p>
        </section>
        <section class="cards">
            <section>
                <div class="items" v-if="!load">
                    <div class="item" v-for="(role, index) in roles" :key="role.id">
                        <div>{{role.name}}</div>
                        <div class="ctr-permissions" v-if="isPermission('config_permissions_user')">
                            <button type="button" @click="goTo(role)">
                                <i class="fal fa-key"></i>
                            </button>
                        </div>
                        <div class="ctr-remove">
                            <button type="button" @click="remove(role, index)" :disabled="role.disableDelete">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <section class="load" v-if="load"></section>
            </section>
            <div class="controls" v-if="!load">
                <button type="button" @click="add()">
                    <i class="fal fa-plus"></i>
                </button>
            </div>
        </section>

        <ui-modal id="modal-add" title="Tipo de Usuário" title-text="Escreva o nome do novo tipo de usuário." size="sm">
            <form v-on:submit.prevent="addConfirm" v-if="!loadSave">
                <div class="msg" v-if="message">{{message}}</div>
                <div class="input-box">
                    <input id="input-empresa" type="text" placeholder="Digite o seu e-mail" v-model="form.name">
                    <label for="input-empresa">
                        <span>Nome:</span>
                    </label>
                </div>
                <div class="control">
                    <button type="submit" v-if="form.name.length > 3">Salvar</button>
                </div>
            </form>
            <section class="load" v-if="loadSave"></section>
        </ui-modal>

        <ui-modal id="modal-remove" title="Confirmar Exclusão" title-text="Tem certeza que deseja excluir esse tipo de usuário?" size="xs">
            <div class="control" v-if="!loadRemove">
                <button type="button" class="btn-cancel" @click="hideModal('modal-remove')">Cancelar</button>
                <button type="button" class="btn-confirm" @click="removeConfirm()">Confirmar</button>
            </div>
            <section class="load" v-if="loadRemove"></section>
        </ui-modal>

    </section>
</template>

<script>
    import { uiModal } from '@/components'
    import { roles } from '@/services'
    import permissions from '@/mixins/permissions'
    export default {
        components: { uiModal },
        mixins: [ permissions ],
        data() {
            return {
                roles: [
                    {
                        id: 0,
                        slug: 'administrator',
                        name: 'Administrador',
                        disableDelete: true,
                    }
                ],
                role: null,
                index: null,
                form: {
                    name: ''
                },
                message: '',
                load: false,
                loadSave: false,
                loadRemove: false,
            }
        },
        methods: {
            goTo(role){
                this.$router.push({
                    path: '/configuracoes/permissoes/' + role.slug,
                })
            },
            listRoles(){
                this.load = true
                roles.read().then( response => {
                    this.roles = [...this.roles, ...response.data]
                    this.load = false
                })
            },
            remove(role, index){
                this.$root.$emit("modal", 'modal-remove');
                this.role = role
                this.index = index
            },
            removeConfirm(){
                this.loadRemove = true
                roles.destroy(this.role.id).then( () => {
                    this.$delete(this.roles, this.index)
                    this.hideModal('modal-remove')
                    setTimeout( () => {
                        this.loadRemove = false
                    }, 1000)
                })
            },

            add(){
                this.$root.$emit("modal", 'modal-add');
                this.form.name = ''
                this.message = ''
            },

            addConfirm(){
                this.loadSave = true
                roles.save(this.form).then( response => {
                    this.roles.push(response.data.row)
                    this.hideModal('modal-add')
                    this.loadSave = false
                }, error =>  {
                    this.message = error.response.data.message
                })
            },

            hideModal(modalID){
                this.$root.$emit("modal-close", modalID);
                this.role = {}
                this.index = null
                this.loadSave = false
            }
        },
        created(){
            this.listRoles()
		}
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
